import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Carousel from "@brainhubeu/react-carousel";
import { media } from "utils/media";
import mdToHtml from "../utils/mdToHtml";
import isExternalUrl from "../utils/isExternalUrl";

import { Image, Link } from "components";
// import { highlightsData } from "utils/config/highlights";

const Highlights = ({ content, className }) => {
  if (content.enabled) return false;

  const settings = {
    autoPlay: 3000,
    centered: false,
    clickToChange: true,
    dots: true,
    infinite: true,
    slidesPerPage: 3,
    slidesPerScroll: 1,
    stopAutoPlayOnHover: true,
    breakpoints: {
      1200: {
        slidesPerPage: 2,
      },
      750: {
        clickToChange: false,
        slidesPerPage: 1,
      },
    },
  };

  return (
    <div className={cx("section-highlights", [className])}>
      <h3>News & Highlights</h3>
      <Carousel {...settings}>
        {content.articles.map(({ image, title, text, buttonUrl, buttonText }, idx) => (
          <div key={idx} className="highlight-wrapper">
            <div className="section-media">
              <Image url={media(image)} alt={title} />
            </div>
            <div className="section-text">
              <h4 dangerouslySetInnerHTML={{ __html: title }} />
              <div dangerouslySetInnerHTML={{ __html: mdToHtml(text) }} />
              <Link
                to={buttonUrl}
                className="mt-a"
                dangerouslySetInnerHTML={{ __html: buttonText }}
                external={isExternalUrl(buttonUrl)}
              />
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

Highlights.propTypes = {
  className: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
};

Highlights.defaultProps = {
  className: "",
  content: {},
};

export default Highlights;
